import React from 'react';
import { Col, Row } from 'antd';
import { FaCheckCircle } from 'react-icons/fa';



const UseSMT = () => {

    return (
        <>

            <section className="cta -type-4 d-none">
                <div className="container">
                    <div className="cta__content">
                        <Row gutter={16}>
                            <Col md={12}>
                                <h2 className="fw-bold mb-1">
                                    Use SuperbWorldTrip
                                </h2>
                                <p className="mt-10 mb-3">
                                    You can make your travel more convenient and comfortable by using the SuperbWorldTrip
                                    Kerala Tour Package. We provide various Kerala tour packages for all types of
                                    travelers. Moreover, we also provide all our clients with the best deals and
                                    offers and the below-listed facilities.
                                </p>
                                <ul className='mb-2 gap-2'>
                                    <li><FaCheckCircle /> Easy booking</li>
                                    <li><FaCheckCircle /> Low-cost price</li>
                                    <li><FaCheckCircle /> Customized tour packages</li>
                                    <li><FaCheckCircle /> End-to-End Assistance</li>
                                    <li><FaCheckCircle /> Amazing deals</li>
                                    <li><FaCheckCircle /> Customer Service Orientated</li>
                                </ul>
                                <a href='#' className="btn btn-primary mt-1 px-3">Book Your Trip Now</a></Col>
                            <div className="cta__image">
                                <img loading="lazy" alt="image" width={440} height={375} style={{ color: 'transparent' }} srcSet="https://viatour-nextjs.vercel.app/_next/image?url=%2Fimg%2Fcta%2F11%2F1.jpg&amp;w=1920&amp;q=75" />
                                <img loading="lazy" alt="image" width={21} height={250} style={{ color: 'transparent', width: 'auto', height: '100%' }} src="https://viatour-nextjs.vercel.app/img/cta/11/shape.svg" />
                                <img loading="lazy" alt="image" width={254} height={23} style={{ color: 'transparent' }} src="https://viatour-nextjs.vercel.app/img/cta/11/mobileShape.svg" />
                            </div>
                        </Row>
                    </div>
                </div>
            </section>

            <section className="useSMT ptb-70">
                <div className="container">
                    <Row gutter={16} className='mb-4'>
                        <Col md={12}>
                            <h2 className="fs-1 fw-bold mb-2">
                                Use SuperbWorldTrip
                            </h2>
                            <p className="mt-10 mb-3">
                                You can make your travel more convenient and comfortable by using the SuperbWorldTrip
                                Kerala Tour Package. We provide various Kerala tour packages for all types of
                                travelers. Moreover, we also provide all our clients with the best deals and
                                offers and the below-listed facilities.
                            </p>
                            <a href='#' className="btn btn-primary mt-1 mb-md-0 mb-4 px-4">Book Your Trip Now</a>
                        </Col>
                        <Col md={12}>
                            <img loading="lazy" alt="image" height={210} srcSet="https://techsometimes.com/products/html/travexia/assets/img/home-01/funfact/funfact-1.jpg" />
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col md={24}>
                            <ul className='mb-2 gap-2'>
                                <li><FaCheckCircle /> Easy booking</li>
                                <li><FaCheckCircle /> Low-cost price</li>
                                <li><FaCheckCircle /> Customized tour packages</li>
                                <li><FaCheckCircle /> End-to-End Assistance</li>
                                <li><FaCheckCircle /> Amazing deals</li>
                                <li><FaCheckCircle /> Customer Service Orientated</li>
                            </ul>
                        </Col>
                    </Row>
                </div>
            </section>

        </>

    );
}

export default UseSMT

